/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

/* eslint-disable */
// src/routes.js

import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Person from "layouts/person";
import Local from "layouts/local";
import Machine from "layouts/machine";
import MachineType from "layouts/machineType";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import LocalMachine from "layouts/localMachine";
import VisitMachine from "layouts/visitMachine";
import AllVisitTransactionByLocal from "layouts/localMachine/allVisitTransactionByLocal";
import SlotAccounting from "layouts/slotAccounting";
import SelectedVisitTransactionDetails from "components/VisitTransactionDetails/selectedVisitTransactionDetails";
import AllVisitTransactions from "layouts/allVisitTransactions/allVisitTransactions";
import InactivePersons from "layouts/person/inactive";
import InactiveLocals from "layouts/local/inactive";
import EliminatedMachines from "layouts/machine/inactive";
import InUseMachines from "layouts/machine/inuse";
import LocalDeposito from "layouts/localDeposito";
import LocalDesechos from "layouts/localDesechos";
import AuthorizedDeviceStatus from "layouts/authorizedDeviceStatus";
import Security from "layouts/security";

import Icon from "@mui/material/Icon";

const AUTHENTICATED_ROLES = ["admin", "user"];
const ADMIN_ROLES = ["admin"];

const routes = [
  {
    type: "collapse",
    name: "Inicio",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Clientes",
    key: "person",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/person",
    component: <Person />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Máquinas",
    key: "machine",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/machine",
    component: <Machine />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Máquinas inactivas",
    key: "inactiveMachine",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/machine/eliminated",
    component: <EliminatedMachines />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Máquinas en uso",
    key: "inUseMachine",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/machine/inuse",
    component: <InUseMachines />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Locales",
    key: "local",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/local",
    component: <Local />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Tipos de máquina",
    key: "machineType",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/machineType",
    component: <MachineType />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Depósitos",
    key: "localDeposito",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/localDeposito",
    component: <LocalDeposito />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Bajas",
    key: "localDesechos",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/localDesechos",
    component: <LocalDesechos />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  /* {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Billing />,
  }, */
  /* {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  }, */
  {
    type: "route",
    name: "Iniciar sesión",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
  {
    type: "route",
    name: "Máquinas del Local",
    key: "local-machine",
    icon: <Icon fontSize="small">info</Icon>,
    route: "/local/:id",
    component: <LocalMachine />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Recaudación",
    key: "visit-machine-create",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/local/:id/visitMachine/nuevo",
    component: <VisitMachine />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Editar recaudación",
    key: "visit-machine-edit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/local/:id/visitMachine/:visitId/editar",
    component: <VisitMachine />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Detalle de Recaudación",
    key: "visit-details",
    icon: <Icon fontSize="small">info</Icon>,
    route: "/visit-details/:id",
    component: <SelectedVisitTransactionDetails />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Ingresos",
    key: "all-recaudaciones",
    icon: <Icon fontSize="small">info</Icon>,
    route: "/local/:id/recaudaciones",
    component: <AllVisitTransactionByLocal />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Recaudaciones",
    key: "slot-accounting",
    icon: <Icon fontSize="small">info</Icon>,
    route: "/local/:id/recaudaciones/tragamonedas",
    component: <SlotAccounting />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Detalle Recaudación",
    key: "visit-transaction-detail",
    icon: <Icon fontSize="small">info</Icon>,
    route: "/local/:id/recaudaciones/:visitId",
    component: <SelectedVisitTransactionDetails />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Ingresos general",
    key: "allVisitTransactions",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/allVisitTransactions",
    component: <AllVisitTransactions />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Estado del dispositivo",
    key: "authorized-device-status",
    icon: <Icon fontSize="small">devices</Icon>,
    route: "/authorized-device-status",
    component: <AuthorizedDeviceStatus />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "collapse",
    name: "Seguridad",
    key: "security",
    icon: <Icon fontSize="small">security</Icon>,
    route: "/security",
    component: <Security />,
    private: true,
    roles: ADMIN_ROLES,
  },
  {
    type: "route",
    name: "Personas inactivas",
    key: "person-inactive",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/client/inactive",
    component: <InactivePersons />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
  {
    type: "route",
    name: "Locales inactivos",
    key: "local-inactive",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/local/inactive",
    component: <InactiveLocals />,
    private: true,
    roles: AUTHENTICATED_ROLES,
  },
];

export default routes;
